import React from 'react';
import { Link } from 'react-router-dom';
import BannerSlider from './BannerSlider';
import TestimonialSlider from './TestimonialSlider';

function Home() {
  return (
    <div>    
    {/* bannerslider */}
    <BannerSlider/>
    {/* bannerslider */}
    <section className="section-padding section">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6">
                    <div className="image mb-xl-30">
                        <img src="/tm/react/roboto/assets/images/about.jpg" alt="img" className="image-fit"/>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="section-header">
                        <p className="section_count"></p>
                        <h3 className="title">the quickest and innovative idea with the innovative intelligence solution Type a message</h3>
                    </div>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat</p>
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="icon_box">
                                <i className="flaticon-diagram"></i>
                                <h5 className="title mb-0">All Device<br /> Testing System</h5>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="icon_box">
                                <i className="flaticon-robotic-arm"></i>
                                <h5 className="title mb-0">Robots<br /> Engineering</h5>
                            </div>
                        </div>
                    </div>
                    <Link to="/about" className="thm-btn btn-rounded mb-xl-30">
                        <span className="button_title">Read More</span>
                    </Link>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- About End -->
    <!-- Services Start --> */}
    <section className="section-padding section thm-bg-light">
        <div className="container">
            <div className="section-header text-center">
                <p className="section_count"></p>
                <h3 className="title">Our Services</h3>
            </div>
            <div className="row justify-content-center">
                <div className="col-lg-4 col-md-6">
                    <Link to="/service-details" className="service_box">
                        <i className="flaticon-machine-learning icon"></i>
                        <h5 className="title">Machine Learning</h5>
                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation </p>
                    </Link>
                </div>
               
                <div className="col-lg-4 col-md-6">
                    <Link to="/service-details" className="service_box">
                        <i className="flaticon-vision icon"></i>
                        <h5 className="title">Manage Analytics</h5>
                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation </p>
                    </Link>
                </div>
               
                <div className="col-lg-4 col-md-6">
                    <Link to="/service-details" className="service_box">
                        <i className="flaticon-chatbot icon"></i>
                        <h5 className="title">Industrial Robot </h5>
                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation </p>
                    </Link>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Services End -->
    <!-- Cta Start --> */}
    <section className="section-padding section">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-5">
                    <div className="section-header">
                        <p className="section_count"></p>
                        <h3 className="title">We Provide The Immediate Solution</h3>
                    </div>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
                    <Link to="/about" className="thm-btn btn-rounded mb-xl-30">
                        <span className="button_title">Learn More</span>
                    </Link>
                </div>
                <div className="col-lg-7">
                    <div className="image mb-xl-30">
                        <img src="/tm/react/roboto/assets/images/cta.jpg" alt="img" className="image-fit"/>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Cta End -->
    <!-- How It Work Start --> */}
    <section className="section-parallax section-padding how-it-works-parent" style={{ backgroundImage: 'url(/tm/react/roboto/assets/images/howitworks.jpg)' }}>
        <div className="container">
            <div className="section-header text-center">
                <p className="section_count"></p>
                <h3 className="title text-white">How It Works</h3>
            </div>
        </div>
    </section>
    <div className="how-it-works-sub">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-3 col-md-6">
                    <Link to="/service-details" className="service_box style_2">
                        <i className="flaticon-circuit icon"></i>
                        <h5 className="title">Enter Your Detail</h5>
                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
                    </Link>
                </div>
                
                <div className="col-lg-3 col-md-6">
                    <Link to="/service-details" className="service_box style_2">
                        <i className="flaticon-circuit-1 icon"></i>
                        <h5 className="title">Import Data For</h5>
                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
                    </Link>
                </div>
                
                <div className="col-lg-3 col-md-6">
                    <Link to="/service-details" className="service_box style_2">
                        <i className="flaticon-machine-learning icon"></i>
                        <h5 className="title">Create Account</h5>
                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
                    </Link>
                </div>
              
                <div className="col-lg-3 col-md-6">
                    <Link to="/service-details" className="service_box style_2">
                        <i className="flaticon-brain icon"></i>
                        <h5 className="title">Play For Handover</h5>
                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
                    </Link>
                </div>
                <div className="col-12 text-center">
                    <Link to="/services" className="thm-btn btn-rounded">
                        <span className="button_title">View More</span>
                    </Link>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- How It Work end -->
    <!-- Team Start --> */}
    <section className="section-padding section">
        <div className="container">
            <div className="section-header text-center">
                <p className="section_count"></p>
                <h3 className="title">Our Team</h3>
            </div>
            <div className="row">
                <div className="col-lg-3 col-md-6">
                    <div className="team_block">
                        <div className="team_img">
                            <img src="/tm/react/roboto/assets/images/team/1.jpg" alt="img" className="image-fit"/>
                        </div>
                        <div className="team_caption">
                            <h5 className="team_name"><Link to="/team">Bratt Lee</Link></h5>
                            <p className="team_post">Manager</p>
                            <button type="button" className="team_share">
                                <i className="fas fa-share-alt"></i>
                            </button>
                            <ul className="social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-linkedin-in"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
               
                <div className="col-lg-3 col-md-6">
                    <div className="team_block">
                        <div className="team_img">
                            <img src="/tm/react/roboto/assets/images/team/2.jpg" alt="img" className="image-fit"/>
                        </div>
                        <div className="team_caption">
                            <h5 className="team_name"><Link to="/team">Jacks Kallis</Link></h5>
                            <p className="team_post">Manager</p>
                            <button type="button" className="team_share">
                                <i className="fas fa-share-alt"></i>
                            </button>
                            <ul className="social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-linkedin-in"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
               
                <div className="col-lg-3 col-md-6">
                    <div className="team_block">
                        <div className="team_img">
                            <img src="/tm/react/roboto/assets/images/team/3.jpg" alt="img" className="image-fit"/>
                        </div>
                        <div className="team_caption">
                            <h5 className="team_name"><Link to="/team">Jhon Deo</Link></h5>
                            <p className="team_post">Manager</p>
                            <button type="button" className="team_share">
                                <i className="fas fa-share-alt"></i>
                            </button>
                            <ul className="social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-linkedin-in"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
               
                <div className="col-lg-3 col-md-6">
                    <div className="team_block">
                        <div className="team_img">
                            <img src="/tm/react/roboto/assets/images/team/4.jpg" alt="img" className="image-fit"/>
                        </div>
                        <div className="team_caption">
                            <h5 className="team_name"><Link to="/team">Robin Albert</Link></h5>
                            <p className="team_post">Manager</p>
                            <button type="button" className="team_share">
                                <i className="fas fa-share-alt"></i>
                            </button>
                            <ul className="social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-linkedin-in"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Team End -->
    <!-- Testimonials Start --> */}
    <TestimonialSlider/>
    {/* <!-- Testimonials End -->
    <!-- Blog Start --> */}
    <section className="section-padding section">
        <div className="container">
            <div className="section-header text-center">
                <p className="section_count"></p>
                <h3 className="title">Latest News</h3>
            </div>
            <div className="row justify-content-center">
                <article className="col-lg-4 col-md-6">
                    <div className="post">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/roboto/assets/images/blog/1.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <div className="post_date">15 Fab 2024</div>
                            <h2 className="post_title"><Link to="/blog-details">Facing problem to get solution of your queries? Here is the solution</Link></h2>
                        </div>
                    </div>
                </article>
               
                <article className="col-lg-4 col-md-6">
                    <div className="post">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/roboto/assets/images/blog/2.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <div className="post_date">22 Fab 2024</div>
                            <h2 className="post_title"><Link to="/blog-details">Better solution to make your business more effective</Link></h2>
                        </div>
                    </div>
                </article>
              
                <article className="col-lg-4 col-md-6">
                    <div className="post">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/roboto/assets/images/blog/3.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <div className="post_date">05 Fab 2024</div>
                            <h2 className="post_title"><Link to="/blog-details">Platform where your problems meet with their solution</Link></h2>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    </section>
    {/*  */}
    <section className="section-padding section section-parallax contact_bg" style={{ backgroundImage: 'url(/tm/react/roboto/assets/images/contact_bg.jpg)' }}>
        <div className="container">
            <div className="section-header text-center">
                <p className="section_count"></p>
                <h3 className="title text-white">Get In Touch</h3>
            </div>
            <form action="#" method="POST" className="row form_style">
                <div className="col-lg-4 col-md-6">
                    <div className="form-group">
                        <label>Your Name</label>
                        <input type="text" name="#" className="form-control" placeholder="Your Name" autoComplete="off" required/>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6">
                    <div className="form-group">
                        <label>Your Email</label>
                        <input type="email" name="#" className="form-control" placeholder="Your Email" autoComplete="off" required/>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6">
                    <div className="form-group">
                        <label>Your Phone</label>
                        <input type="text" name="#" className="form-control" placeholder="Your Phone" autoComplete="off" required/>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="form-group">
                        <button type="submit" className="thm-btn btn-rounded w-100">
                            <span className="button_title">View More</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </section>    
    </div>
  )
}

export default Home